import React, { useState } from 'react';
import { AccordionContainer } from './CustomAccordion.styled';
import { SegmentSubTitle } from '../../../../SegmentSettings/SegmentSettings.styled';
import TextView from '../../../../TextView';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ContentEditable from 'react-contenteditable';
import { sanitizeUserHtml } from '../../../../../utils/sanitizeHtml';

const CustomAccordion = ({
  header,
  expanded,
  onToggle,
  children,
  dropDownRightIcon,
  dropDownIconColor = "#FFFFFF",
  borderColor,
  borderWidth,
  borderRadius,
  headerBgColor,
  isHeaderHtml = false,
  dropShadowColor,
  headerOpacity,
  // ACCORDION_HEADER_BACKGROUNDS (DL-037 / N39). Both default to the legacy look so
  // the OFF path is byte-identical: no structured fill, always-white title.
  headerFillCss,
  titleColor = "white",
}) => {
  const handleToggle = (e) => {
    e.stopPropagation(); // Prevent event bubbling
    if (onToggle) {
      onToggle();
    }
  };

  const getIcon = () => {
    const iconStyle = { color: dropDownIconColor };
    if (dropDownRightIcon === 0) {
      return expanded ? (
        <KeyboardArrowUpIcon style={iconStyle} />
      ) : (
        <ExpandMoreIcon style={iconStyle} />
      );
    }
    return expanded ? (
      <RemoveIcon style={iconStyle} />
    ) : (
      <AddIcon style={iconStyle} />
    );
  };

  // console.log(isHeaderHtml,"isHeaderHtmlisHeaderHtmlisHeaderHtmlisHeaderHtml")
  return (
    <AccordionContainer
      borderColor={borderColor}
      borderWidth={borderWidth}
      borderRadius={borderRadius}
      headerBgColor={headerBgColor}
      headerFillCss={headerFillCss}
      titleColor={titleColor}
      dropShadowColor={dropShadowColor}
      headerOpacity={headerOpacity}
      className={expanded ? 'expanded' : ''}
    >
      <div 
        className="accordion-summary" 
        onClick={handleToggle}
        onMouseDown={(e) => e.stopPropagation()} // Prevent drag events from interfering
      >
        {isHeaderHtml ? (
          <>
            <ContentEditable html={sanitizeUserHtml(header)} className="textContentEditable" disabled style={{color: titleColor}}/>
          </>
        ) : (
          <TextView style={{color: titleColor}}>{header}</TextView>
        )}
        {getIcon()}
      </div>
      {expanded ? <div>{children}</div> : null}
    </AccordionContainer>
  );
};

export default CustomAccordion;
